import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    label: {
        '&[data-error="true"]': {
            color: theme.palette.error.main,
        },
        '& > p': {
            margin: 0,
        },
        fontWeight: 500,
        fontSize: '0.875rem',
        width: 'fit-content',
    },
    textarea: {
        width: 425,
        padding: '0.5rem',
        resize: 'none',
        fontFamily:
            "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
        border: `1px solid ${theme.palette.grey.border}`,
        '&[data-error="true"]': {
            borderColor: theme.palette.error.main,
        },
        borderRadius: '8px',
        '&:focus-visible': {
            border: `2px solid ${theme.palette.primary.main}`,
            '&[data-error="true"]': {
                borderColor: theme.palette.error.main,
            },
            outline: 'none',
        },
    },
    spinner: {
        animation: 'spin 2s linear infinite',
        marginLeft: '1rem',
    },
    invalidReason: {
        display: 'block',
        color: theme.palette.error.main,
    },
    required: {
        '& > p::before': {
            content: '"*"',
            color: '#D24444',
            marginRight: '0.25rem',
        },
    },
}));

export default useStyles;
